import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { Auth } from '../configuration/react';
import logo from '../../assets/img/logo_app.png';
import useAuth from '../../hooks/useAuth0/useAuth';

const AuthRequiredRoute = ({ path, render, allowedJourneys = [1, 2], redirectPath = '/search' }) => {
  const location = useLocation();
  const { authStatus } = useAuth();

  if (authStatus === 'loading') {
    return (
      <div className="loader-full-screen main img-loader">
        <div>
          <img src={logo} alt="" />
          <div>
            <Spinner type="grow" color="secondary" />
            <Spinner type="grow" color="secondary" />
            <Spinner type="grow" color="secondary" />
          </div>
        </div>
      </div>
    );
  }
  if (authStatus === 'success') {
    if (allowedJourneys && Auth.journeys().find((journey) => allowedJourneys.includes(journey))) {
      return <Route path={path} render={render} />;
    }
    return <Redirect to={redirectPath} />;
  }
  return (
    <Redirect
      to={{
        pathname: '/login',
        state: { from: location },
      }}
    />
  );
};

export default AuthRequiredRoute;

AuthRequiredRoute.propTypes = {
  path: PropTypes.string.isRequired,
  render: PropTypes.func.isRequired,
  allowedJourneys: PropTypes.oneOfType([PropTypes.array]),
  redirectPath: PropTypes.string,
};

AuthRequiredRoute.defaultProps = {
  allowedJourneys: [1, 2],
  redirectPath: '/search',
};
